module.exports = __webpack_public_path__ + "img/hist_rgb_before_after.cb4932be.png";